import * as Types from '../../../graphql/generated/types';

import { gql } from '@apollo/client';
import { UserDetailDataFragmentDoc } from '../../../user/user.generated';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type PersonForMergeData_Person_Fragment = {
  __typename?: 'Person';
  id: any;
  createdAt: any;
  title?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  gender?: Types.Gender | null;
  internalNotes?: string | null;
  enterpriseIds?: Array<any> | null;
  contactProperties: Array<{
    __typename?: 'ContactProperty';
    id: any;
    key: Types.ContactPropertyKey;
    value: string;
  }>;
  address: {
    __typename?: 'Address';
    company?: string | null;
    contactPerson?: string | null;
    streetAndNumber?: string | null;
    postalCode?: string | null;
    city?: string | null;
    country?: string | null;
    other?: string | null;
  };
  invoiceAddress: {
    __typename?: 'Address';
    company?: string | null;
    contactPerson?: string | null;
    streetAndNumber?: string | null;
    postalCode?: string | null;
    city?: string | null;
    country?: string | null;
    other?: string | null;
  };
  employments: Array<{
    __typename?: 'Employment';
    id: any;
    description?: string | null;
    companyId: any;
    company: { __typename?: 'Company'; id: any; name: string };
  }>;
  enterprises: Array<{ __typename?: 'Enterprise'; id: any; name: string }>;
  user?:
    | {
        __typename?: 'Administrator';
        roleIds?: Array<any> | null;
        isBot: boolean;
        id: any;
        username?: string | null;
        fullName: string;
        primaryEmail?: string | null;
        status: Types.UserStatus;
        description?: string | null;
        roles: Array<{ __typename?: 'Role'; id: any; name: Types.RoleType }>;
        image?: { __typename?: 'FilesystemFile'; id: any; url: string } | null;
      }
    | {
        __typename?: 'Customer';
        invoiceEmail?: string | null;
        customerNumber?: string | null;
        id: any;
        username?: string | null;
        fullName: string;
        primaryEmail?: string | null;
        status: Types.UserStatus;
        description?: string | null;
        orders: Array<{
          __typename?: 'Order';
          id: any;
          createdAt: any;
          total: number;
        }>;
        bookings: Array<
          | {
              __typename?: 'CourseModuleBooking';
              kind: Types.BookingKind;
              id: any;
              createdAt: any;
              courseModule: {
                __typename?: 'CourseModule';
                id: any;
                title?: string | null;
                sku: string;
                startDate: any;
                endDate: any;
                dateUncertain: boolean;
                withTime: boolean;
                online: boolean;
                correspondenceCourse: boolean;
                location?: {
                  __typename?: 'Location';
                  id: any;
                  commonName: string;
                } | null;
                secondaryLocation?: {
                  __typename?: 'Location';
                  id: any;
                  commonName: string;
                } | null;
                courseUnit: {
                  __typename?: 'CourseUnit';
                  id: any;
                  course: {
                    __typename?: 'Course';
                    id: any;
                    title: string;
                    verboseTitle?: string | null;
                    abbreviation: string;
                  };
                };
              };
            }
          | {
              __typename?: 'CourseUnitBooking';
              kind: Types.BookingKind;
              id: any;
              createdAt: any;
              courseUnit: {
                __typename?: 'CourseUnit';
                id: any;
                title?: string | null;
                sku: string;
                startDate: any;
                endDate: any;
                dateUncertain: boolean;
                withTime: boolean;
                online: boolean;
                correspondenceCourse: boolean;
                location?: {
                  __typename?: 'Location';
                  id: any;
                  commonName: string;
                } | null;
                secondaryLocation?: {
                  __typename?: 'Location';
                  id: any;
                  commonName: string;
                } | null;
                course: {
                  __typename?: 'Course';
                  id: any;
                  title: string;
                  verboseTitle?: string | null;
                  abbreviation: string;
                };
              };
            }
        >;
        image?: { __typename?: 'FilesystemFile'; id: any; url: string } | null;
      }
    | {
        __typename?: 'Teacher';
        jobTitle?: string | null;
        subjectArea?: string | null;
        slug?: string | null;
        id: any;
        username?: string | null;
        fullName: string;
        primaryEmail?: string | null;
        status: Types.UserStatus;
        description?: string | null;
        image?: { __typename?: 'FilesystemFile'; id: any; url: string } | null;
      }
    | null;
};

export type PersonForMergeData_PersonWithDuplicates_Fragment = {
  __typename?: 'PersonWithDuplicates';
  id: any;
  createdAt: any;
  title?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  gender?: Types.Gender | null;
  internalNotes?: string | null;
  enterpriseIds?: Array<any> | null;
  contactProperties: Array<{
    __typename?: 'ContactProperty';
    id: any;
    key: Types.ContactPropertyKey;
    value: string;
  }>;
  address: {
    __typename?: 'Address';
    company?: string | null;
    contactPerson?: string | null;
    streetAndNumber?: string | null;
    postalCode?: string | null;
    city?: string | null;
    country?: string | null;
    other?: string | null;
  };
  invoiceAddress: {
    __typename?: 'Address';
    company?: string | null;
    contactPerson?: string | null;
    streetAndNumber?: string | null;
    postalCode?: string | null;
    city?: string | null;
    country?: string | null;
    other?: string | null;
  };
  employments: Array<{
    __typename?: 'Employment';
    id: any;
    description?: string | null;
    companyId: any;
    company: { __typename?: 'Company'; id: any; name: string };
  }>;
  enterprises: Array<{ __typename?: 'Enterprise'; id: any; name: string }>;
  user?:
    | {
        __typename?: 'Administrator';
        roleIds?: Array<any> | null;
        isBot: boolean;
        id: any;
        username?: string | null;
        fullName: string;
        primaryEmail?: string | null;
        status: Types.UserStatus;
        description?: string | null;
        roles: Array<{ __typename?: 'Role'; id: any; name: Types.RoleType }>;
        image?: { __typename?: 'FilesystemFile'; id: any; url: string } | null;
      }
    | {
        __typename?: 'Customer';
        invoiceEmail?: string | null;
        customerNumber?: string | null;
        id: any;
        username?: string | null;
        fullName: string;
        primaryEmail?: string | null;
        status: Types.UserStatus;
        description?: string | null;
        orders: Array<{
          __typename?: 'Order';
          id: any;
          createdAt: any;
          total: number;
        }>;
        bookings: Array<
          | {
              __typename?: 'CourseModuleBooking';
              kind: Types.BookingKind;
              id: any;
              createdAt: any;
              courseModule: {
                __typename?: 'CourseModule';
                id: any;
                title?: string | null;
                sku: string;
                startDate: any;
                endDate: any;
                dateUncertain: boolean;
                withTime: boolean;
                online: boolean;
                correspondenceCourse: boolean;
                location?: {
                  __typename?: 'Location';
                  id: any;
                  commonName: string;
                } | null;
                secondaryLocation?: {
                  __typename?: 'Location';
                  id: any;
                  commonName: string;
                } | null;
                courseUnit: {
                  __typename?: 'CourseUnit';
                  id: any;
                  course: {
                    __typename?: 'Course';
                    id: any;
                    title: string;
                    verboseTitle?: string | null;
                    abbreviation: string;
                  };
                };
              };
            }
          | {
              __typename?: 'CourseUnitBooking';
              kind: Types.BookingKind;
              id: any;
              createdAt: any;
              courseUnit: {
                __typename?: 'CourseUnit';
                id: any;
                title?: string | null;
                sku: string;
                startDate: any;
                endDate: any;
                dateUncertain: boolean;
                withTime: boolean;
                online: boolean;
                correspondenceCourse: boolean;
                location?: {
                  __typename?: 'Location';
                  id: any;
                  commonName: string;
                } | null;
                secondaryLocation?: {
                  __typename?: 'Location';
                  id: any;
                  commonName: string;
                } | null;
                course: {
                  __typename?: 'Course';
                  id: any;
                  title: string;
                  verboseTitle?: string | null;
                  abbreviation: string;
                };
              };
            }
        >;
        image?: { __typename?: 'FilesystemFile'; id: any; url: string } | null;
      }
    | {
        __typename?: 'Teacher';
        jobTitle?: string | null;
        subjectArea?: string | null;
        slug?: string | null;
        id: any;
        username?: string | null;
        fullName: string;
        primaryEmail?: string | null;
        status: Types.UserStatus;
        description?: string | null;
        image?: { __typename?: 'FilesystemFile'; id: any; url: string } | null;
      }
    | null;
};

export type PersonForMergeDataFragment =
  | PersonForMergeData_Person_Fragment
  | PersonForMergeData_PersonWithDuplicates_Fragment;

export type PersonWithDuplicatesQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;

export type PersonWithDuplicatesQuery = {
  __typename?: 'Query';
  personWithDuplicates: {
    __typename?: 'PersonWithDuplicates';
    id: any;
    createdAt: any;
    title?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    gender?: Types.Gender | null;
    internalNotes?: string | null;
    enterpriseIds?: Array<any> | null;
    duplicates?: Array<{
      __typename?: 'Duplicate';
      reasons: Array<string>;
      isManuallyLinked: boolean;
      person1: {
        __typename?: 'Person';
        id: any;
        createdAt: any;
        title?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        gender?: Types.Gender | null;
        internalNotes?: string | null;
        enterpriseIds?: Array<any> | null;
        contactProperties: Array<{
          __typename?: 'ContactProperty';
          id: any;
          key: Types.ContactPropertyKey;
          value: string;
        }>;
        address: {
          __typename?: 'Address';
          company?: string | null;
          contactPerson?: string | null;
          streetAndNumber?: string | null;
          postalCode?: string | null;
          city?: string | null;
          country?: string | null;
          other?: string | null;
        };
        invoiceAddress: {
          __typename?: 'Address';
          company?: string | null;
          contactPerson?: string | null;
          streetAndNumber?: string | null;
          postalCode?: string | null;
          city?: string | null;
          country?: string | null;
          other?: string | null;
        };
        employments: Array<{
          __typename?: 'Employment';
          id: any;
          description?: string | null;
          companyId: any;
          company: { __typename?: 'Company'; id: any; name: string };
        }>;
        enterprises: Array<{
          __typename?: 'Enterprise';
          id: any;
          name: string;
        }>;
        user?:
          | {
              __typename?: 'Administrator';
              roleIds?: Array<any> | null;
              isBot: boolean;
              id: any;
              username?: string | null;
              fullName: string;
              primaryEmail?: string | null;
              status: Types.UserStatus;
              description?: string | null;
              roles: Array<{
                __typename?: 'Role';
                id: any;
                name: Types.RoleType;
              }>;
              image?: {
                __typename?: 'FilesystemFile';
                id: any;
                url: string;
              } | null;
            }
          | {
              __typename?: 'Customer';
              invoiceEmail?: string | null;
              customerNumber?: string | null;
              id: any;
              username?: string | null;
              fullName: string;
              primaryEmail?: string | null;
              status: Types.UserStatus;
              description?: string | null;
              orders: Array<{
                __typename?: 'Order';
                id: any;
                createdAt: any;
                total: number;
              }>;
              bookings: Array<
                | {
                    __typename?: 'CourseModuleBooking';
                    kind: Types.BookingKind;
                    id: any;
                    createdAt: any;
                    courseModule: {
                      __typename?: 'CourseModule';
                      id: any;
                      title?: string | null;
                      sku: string;
                      startDate: any;
                      endDate: any;
                      dateUncertain: boolean;
                      withTime: boolean;
                      online: boolean;
                      correspondenceCourse: boolean;
                      location?: {
                        __typename?: 'Location';
                        id: any;
                        commonName: string;
                      } | null;
                      secondaryLocation?: {
                        __typename?: 'Location';
                        id: any;
                        commonName: string;
                      } | null;
                      courseUnit: {
                        __typename?: 'CourseUnit';
                        id: any;
                        course: {
                          __typename?: 'Course';
                          id: any;
                          title: string;
                          verboseTitle?: string | null;
                          abbreviation: string;
                        };
                      };
                    };
                  }
                | {
                    __typename?: 'CourseUnitBooking';
                    kind: Types.BookingKind;
                    id: any;
                    createdAt: any;
                    courseUnit: {
                      __typename?: 'CourseUnit';
                      id: any;
                      title?: string | null;
                      sku: string;
                      startDate: any;
                      endDate: any;
                      dateUncertain: boolean;
                      withTime: boolean;
                      online: boolean;
                      correspondenceCourse: boolean;
                      location?: {
                        __typename?: 'Location';
                        id: any;
                        commonName: string;
                      } | null;
                      secondaryLocation?: {
                        __typename?: 'Location';
                        id: any;
                        commonName: string;
                      } | null;
                      course: {
                        __typename?: 'Course';
                        id: any;
                        title: string;
                        verboseTitle?: string | null;
                        abbreviation: string;
                      };
                    };
                  }
              >;
              image?: {
                __typename?: 'FilesystemFile';
                id: any;
                url: string;
              } | null;
            }
          | {
              __typename?: 'Teacher';
              jobTitle?: string | null;
              subjectArea?: string | null;
              slug?: string | null;
              id: any;
              username?: string | null;
              fullName: string;
              primaryEmail?: string | null;
              status: Types.UserStatus;
              description?: string | null;
              image?: {
                __typename?: 'FilesystemFile';
                id: any;
                url: string;
              } | null;
            }
          | null;
      };
      person2: {
        __typename?: 'Person';
        id: any;
        createdAt: any;
        title?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        gender?: Types.Gender | null;
        internalNotes?: string | null;
        enterpriseIds?: Array<any> | null;
        contactProperties: Array<{
          __typename?: 'ContactProperty';
          id: any;
          key: Types.ContactPropertyKey;
          value: string;
        }>;
        address: {
          __typename?: 'Address';
          company?: string | null;
          contactPerson?: string | null;
          streetAndNumber?: string | null;
          postalCode?: string | null;
          city?: string | null;
          country?: string | null;
          other?: string | null;
        };
        invoiceAddress: {
          __typename?: 'Address';
          company?: string | null;
          contactPerson?: string | null;
          streetAndNumber?: string | null;
          postalCode?: string | null;
          city?: string | null;
          country?: string | null;
          other?: string | null;
        };
        employments: Array<{
          __typename?: 'Employment';
          id: any;
          description?: string | null;
          companyId: any;
          company: { __typename?: 'Company'; id: any; name: string };
        }>;
        enterprises: Array<{
          __typename?: 'Enterprise';
          id: any;
          name: string;
        }>;
        user?:
          | {
              __typename?: 'Administrator';
              roleIds?: Array<any> | null;
              isBot: boolean;
              id: any;
              username?: string | null;
              fullName: string;
              primaryEmail?: string | null;
              status: Types.UserStatus;
              description?: string | null;
              roles: Array<{
                __typename?: 'Role';
                id: any;
                name: Types.RoleType;
              }>;
              image?: {
                __typename?: 'FilesystemFile';
                id: any;
                url: string;
              } | null;
            }
          | {
              __typename?: 'Customer';
              invoiceEmail?: string | null;
              customerNumber?: string | null;
              id: any;
              username?: string | null;
              fullName: string;
              primaryEmail?: string | null;
              status: Types.UserStatus;
              description?: string | null;
              orders: Array<{
                __typename?: 'Order';
                id: any;
                createdAt: any;
                total: number;
              }>;
              bookings: Array<
                | {
                    __typename?: 'CourseModuleBooking';
                    kind: Types.BookingKind;
                    id: any;
                    createdAt: any;
                    courseModule: {
                      __typename?: 'CourseModule';
                      id: any;
                      title?: string | null;
                      sku: string;
                      startDate: any;
                      endDate: any;
                      dateUncertain: boolean;
                      withTime: boolean;
                      online: boolean;
                      correspondenceCourse: boolean;
                      location?: {
                        __typename?: 'Location';
                        id: any;
                        commonName: string;
                      } | null;
                      secondaryLocation?: {
                        __typename?: 'Location';
                        id: any;
                        commonName: string;
                      } | null;
                      courseUnit: {
                        __typename?: 'CourseUnit';
                        id: any;
                        course: {
                          __typename?: 'Course';
                          id: any;
                          title: string;
                          verboseTitle?: string | null;
                          abbreviation: string;
                        };
                      };
                    };
                  }
                | {
                    __typename?: 'CourseUnitBooking';
                    kind: Types.BookingKind;
                    id: any;
                    createdAt: any;
                    courseUnit: {
                      __typename?: 'CourseUnit';
                      id: any;
                      title?: string | null;
                      sku: string;
                      startDate: any;
                      endDate: any;
                      dateUncertain: boolean;
                      withTime: boolean;
                      online: boolean;
                      correspondenceCourse: boolean;
                      location?: {
                        __typename?: 'Location';
                        id: any;
                        commonName: string;
                      } | null;
                      secondaryLocation?: {
                        __typename?: 'Location';
                        id: any;
                        commonName: string;
                      } | null;
                      course: {
                        __typename?: 'Course';
                        id: any;
                        title: string;
                        verboseTitle?: string | null;
                        abbreviation: string;
                      };
                    };
                  }
              >;
              image?: {
                __typename?: 'FilesystemFile';
                id: any;
                url: string;
              } | null;
            }
          | {
              __typename?: 'Teacher';
              jobTitle?: string | null;
              subjectArea?: string | null;
              slug?: string | null;
              id: any;
              username?: string | null;
              fullName: string;
              primaryEmail?: string | null;
              status: Types.UserStatus;
              description?: string | null;
              image?: {
                __typename?: 'FilesystemFile';
                id: any;
                url: string;
              } | null;
            }
          | null;
      };
    }> | null;
    contactProperties: Array<{
      __typename?: 'ContactProperty';
      id: any;
      key: Types.ContactPropertyKey;
      value: string;
    }>;
    address: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
    invoiceAddress: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
    employments: Array<{
      __typename?: 'Employment';
      id: any;
      description?: string | null;
      companyId: any;
      company: { __typename?: 'Company'; id: any; name: string };
    }>;
    enterprises: Array<{ __typename?: 'Enterprise'; id: any; name: string }>;
    user?:
      | {
          __typename?: 'Administrator';
          roleIds?: Array<any> | null;
          isBot: boolean;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          roles: Array<{ __typename?: 'Role'; id: any; name: Types.RoleType }>;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Customer';
          invoiceEmail?: string | null;
          customerNumber?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          orders: Array<{
            __typename?: 'Order';
            id: any;
            createdAt: any;
            total: number;
          }>;
          bookings: Array<
            | {
                __typename?: 'CourseModuleBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseModule: {
                  __typename?: 'CourseModule';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  courseUnit: {
                    __typename?: 'CourseUnit';
                    id: any;
                    course: {
                      __typename?: 'Course';
                      id: any;
                      title: string;
                      verboseTitle?: string | null;
                      abbreviation: string;
                    };
                  };
                };
              }
            | {
                __typename?: 'CourseUnitBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseUnit: {
                  __typename?: 'CourseUnit';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  course: {
                    __typename?: 'Course';
                    id: any;
                    title: string;
                    verboseTitle?: string | null;
                    abbreviation: string;
                  };
                };
              }
          >;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Teacher';
          jobTitle?: string | null;
          subjectArea?: string | null;
          slug?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | null;
  };
};

export type AdminMergePersonsMutationVariables = Types.Exact<{
  input: Types.MergePersonsInput;
}>;

export type AdminMergePersonsMutation = {
  __typename?: 'Mutation';
  adminMergePersons: { __typename?: 'Person'; id: any };
};

export type AdminMarkNotDuplicateMutationVariables = Types.Exact<{
  person1Id: Types.Scalars['UUID'];
  person2Id: Types.Scalars['UUID'];
}>;

export type AdminMarkNotDuplicateMutation = {
  __typename?: 'Mutation';
  adminMarkNotDuplicate: boolean;
};

export const PersonForMergeDataFragmentDoc = gql`
  fragment PersonForMergeData on PersonInterface {
    id
    createdAt
    title
    firstName
    lastName
    gender
    internalNotes
    contactProperties {
      id
      key
      value
    }
    address {
      company
      contactPerson
      streetAndNumber
      postalCode
      city
      country
      other
    }
    invoiceAddress {
      company
      contactPerson
      streetAndNumber
      postalCode
      city
      country
      other
    }
    employments {
      id
      description
      companyId
      company {
        id
        name
      }
    }
    enterprises {
      id
      name
    }
    enterpriseIds
    user {
      ...UserDetailData
    }
  }
  ${UserDetailDataFragmentDoc}
`;
export const PersonWithDuplicatesDocument = gql`
  query personWithDuplicates($id: UUID!) {
    personWithDuplicates(id: $id) {
      ...PersonForMergeData
      duplicates {
        reasons
        isManuallyLinked
        person1 {
          ...PersonForMergeData
        }
        person2 {
          ...PersonForMergeData
        }
      }
    }
  }
  ${PersonForMergeDataFragmentDoc}
`;
export type PersonWithDuplicatesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    PersonWithDuplicatesQuery,
    PersonWithDuplicatesQueryVariables
  >,
  'query'
> &
  (
    | { variables: PersonWithDuplicatesQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const PersonWithDuplicatesComponent = (
  props: PersonWithDuplicatesComponentProps,
) => (
  <ApolloReactComponents.Query<
    PersonWithDuplicatesQuery,
    PersonWithDuplicatesQueryVariables
  >
    query={PersonWithDuplicatesDocument}
    {...props}
  />
);

/**
 * __usePersonWithDuplicatesQuery__
 *
 * To run a query within a React component, call `usePersonWithDuplicatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonWithDuplicatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonWithDuplicatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePersonWithDuplicatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    PersonWithDuplicatesQuery,
    PersonWithDuplicatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PersonWithDuplicatesQuery,
    PersonWithDuplicatesQueryVariables
  >(PersonWithDuplicatesDocument, options);
}
export function usePersonWithDuplicatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PersonWithDuplicatesQuery,
    PersonWithDuplicatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PersonWithDuplicatesQuery,
    PersonWithDuplicatesQueryVariables
  >(PersonWithDuplicatesDocument, options);
}
export type PersonWithDuplicatesQueryHookResult = ReturnType<
  typeof usePersonWithDuplicatesQuery
>;
export type PersonWithDuplicatesLazyQueryHookResult = ReturnType<
  typeof usePersonWithDuplicatesLazyQuery
>;
export type PersonWithDuplicatesQueryResult = Apollo.QueryResult<
  PersonWithDuplicatesQuery,
  PersonWithDuplicatesQueryVariables
>;
export const AdminMergePersonsDocument = gql`
  mutation adminMergePersons($input: MergePersonsInput!) {
    adminMergePersons(input: $input) {
      id
    }
  }
`;
export type AdminMergePersonsMutationFn = Apollo.MutationFunction<
  AdminMergePersonsMutation,
  AdminMergePersonsMutationVariables
>;
export type AdminMergePersonsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AdminMergePersonsMutation,
    AdminMergePersonsMutationVariables
  >,
  'mutation'
>;

export const AdminMergePersonsComponent = (
  props: AdminMergePersonsComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    AdminMergePersonsMutation,
    AdminMergePersonsMutationVariables
  >
    mutation={AdminMergePersonsDocument}
    {...props}
  />
);

/**
 * __useAdminMergePersonsMutation__
 *
 * To run a mutation, you first call `useAdminMergePersonsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMergePersonsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMergePersonsMutation, { data, loading, error }] = useAdminMergePersonsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMergePersonsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminMergePersonsMutation,
    AdminMergePersonsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminMergePersonsMutation,
    AdminMergePersonsMutationVariables
  >(AdminMergePersonsDocument, options);
}
export type AdminMergePersonsMutationHookResult = ReturnType<
  typeof useAdminMergePersonsMutation
>;
export type AdminMergePersonsMutationResult =
  Apollo.MutationResult<AdminMergePersonsMutation>;
export type AdminMergePersonsMutationOptions = Apollo.BaseMutationOptions<
  AdminMergePersonsMutation,
  AdminMergePersonsMutationVariables
>;
export const AdminMarkNotDuplicateDocument = gql`
  mutation adminMarkNotDuplicate($person1Id: UUID!, $person2Id: UUID!) {
    adminMarkNotDuplicate(person1Id: $person1Id, person2Id: $person2Id)
  }
`;
export type AdminMarkNotDuplicateMutationFn = Apollo.MutationFunction<
  AdminMarkNotDuplicateMutation,
  AdminMarkNotDuplicateMutationVariables
>;
export type AdminMarkNotDuplicateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AdminMarkNotDuplicateMutation,
    AdminMarkNotDuplicateMutationVariables
  >,
  'mutation'
>;

export const AdminMarkNotDuplicateComponent = (
  props: AdminMarkNotDuplicateComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    AdminMarkNotDuplicateMutation,
    AdminMarkNotDuplicateMutationVariables
  >
    mutation={AdminMarkNotDuplicateDocument}
    {...props}
  />
);

/**
 * __useAdminMarkNotDuplicateMutation__
 *
 * To run a mutation, you first call `useAdminMarkNotDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMarkNotDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMarkNotDuplicateMutation, { data, loading, error }] = useAdminMarkNotDuplicateMutation({
 *   variables: {
 *      person1Id: // value for 'person1Id'
 *      person2Id: // value for 'person2Id'
 *   },
 * });
 */
export function useAdminMarkNotDuplicateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminMarkNotDuplicateMutation,
    AdminMarkNotDuplicateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminMarkNotDuplicateMutation,
    AdminMarkNotDuplicateMutationVariables
  >(AdminMarkNotDuplicateDocument, options);
}
export type AdminMarkNotDuplicateMutationHookResult = ReturnType<
  typeof useAdminMarkNotDuplicateMutation
>;
export type AdminMarkNotDuplicateMutationResult =
  Apollo.MutationResult<AdminMarkNotDuplicateMutation>;
export type AdminMarkNotDuplicateMutationOptions = Apollo.BaseMutationOptions<
  AdminMarkNotDuplicateMutation,
  AdminMarkNotDuplicateMutationVariables
>;
